/**
* Created by lobin on 2020/6/18.
*/
<template>
  <a-row :gutter="16">
    <a-col :span="5">
      <a-card :body-style="{padding: '16px 10px'}" :bordered="false" class="cabinet">
        <station-select @select="stationSelect" />
      </a-card>
    </a-col>
    <a-col :span="19">
      <a-card :body-style="{padding: '24px', minHieght: '600px'}" :bordered="false" class="cabinet">
        <div v-if="stationId">
          <a-row :gutter="16">
            <div style="text-align: right">
              <h3 style="float: left">数据统计</h3>
              <a-space>
                <a-select style="width: 120px" @change="handleChange" v-model="year">
                  <a-select-option v-for="item in yearList" :key="item" value="2023" :value="item">
                    {{ item }}年
                  </a-select-option>
                </a-select>
                <a-button type="primary" icon="download" @click="exportData">
                  下载
                </a-button>
              </a-space>
            </div>
            <a-divider />
            <a-col :span="24" class="chart">
              <!-- <h4>月报数据</h4> -->
              <a-spin :spinning="listloading" :delay="300">
                <e-chart :option="options" style="height: 420px;"></e-chart>
              </a-spin>
            </a-col>
          </a-row>
        </div>
        <a-empty v-else description="请选择站点" />
      </a-card>
    </a-col>

  </a-row>
</template>

<script type="text/babel">
import { mapActions } from 'vuex';
import { monthReport } from '@/api/statistic';
import moment from 'moment';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart, BarChart, LineChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  GridComponent,
} from 'echarts/components';
import { downloadUrl } from '../../utils';

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  GridComponent,
  BarChart,
  LineChart,
]);
export default {
  components: {
    EChart: VChart,
  },
  data() {
    return {
      listloading: false,
      stationId: '',
      height: 280,
      style: { stroke: '#fff', lineWidth: 1 },
      dateRange: [],
      range: [],
      year: moment().format('YYYY'),
      yearList: [
        moment().format('YYYY'),
        moment().subtract(1, 'year').format('YYYY'),
        moment().subtract(2, 'year').format('YYYY'),
        moment().subtract(3, 'year').format('YYYY'),
      ],
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        // toolbox: {
        //   feature: {
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ['line', 'bar'] },
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        legend: {
          data: ['派件量', '合计收入', '派件收入', '超时收入', '周转率'],
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            // name: 'Precipitation',
            // interval: 100,
            // axisLabel: {
            //   formatter: '{value} ml'
            // }
          },
          {
            type: 'value',
            // name: 'Temperature',
            // min: 0,
            // interval: 10,
            axisLabel: {
              formatter: '{value}',
            },
          },
        ],
        series: [
          {
            name: '派件量',
            type: 'line',
            smooth: true,
            tooltip: {
              valueFormatter(value) {
                return `${value} 件`;
              },
            },
            data: [

            ],
          },
          {
            name: '合计收入',
            type: 'bar',
            tooltip: {
              valueFormatter(value) {
                return `${value} 元`;
              },
            },
            data: [
            ],
          },
          {
            name: '派件收入',
            type: 'bar',
            tooltip: {
              valueFormatter(value) {
                return `${value} 元`;
              },
            },
            data: [
            ],
          },
          {
            name: '超时收入',
            type: 'bar',
            tooltip: {
              valueFormatter(value) {
                return `${value} 元`;
              },
            },
            data: [],
          },
          {
            name: '周转率',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            tooltip: {
              valueFormatter(value) {
                return `${value} %`;
              },
            },
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(['getStationList']),
    handleChange(val) {
      this.year = val;
      this.getList();
    },
    stationSelect(stationId) {
      this.stationId = stationId;
      this.getList();
    },
    exportData() {
      const id = this.stationId;
      downloadUrl(`/admin/statistic/month-report/export/${id}`, {
        year: this.year,
      });
    },
    async getList() {
      this.listloading = true;
      const { stationId } = this;
      const { year } = this;
      const { data } = await monthReport(stationId, { year });
      this.setDate(data);
      this.listloading = false;
    },
    setDate(sourceData) {
      this.options.xAxis[0].data = sourceData.map((item) => item.month);
      this.options.series[0].data = sourceData.map((item) => item.inboundnum);
      this.options.series[1].data = sourceData.map((item) => (item.profit + item.overTimeFee).toFixed(2));
      this.options.series[2].data = sourceData.map((item) => item.profit);
      this.options.series[3].data = sourceData.map((item) => item.overTimeFee);
      this.options.series[4].data = sourceData.map((item) => (item.cabUseRate * 100).toFixed(2));
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.cabinet {
  .ant-avatar{
    font-size: 20px;
  }
  &-item{
    .ant-avatar{
      background: rgba(0,0,0,.09);
    }
    &.processing{
        .ant-avatar{
          background: rgb(135, 208, 104);
        }
    }
    .warning{
      .ant-avatar{
        background: #faad14;
      }
    }
    &.error{
      .ant-avatar{
        background: #f5222d;
      }
    }
  }
}
.list-content-item {
  color: rgba(0, 0, 0, .45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;
  span {
    line-height: 20px;
  }
  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>
